<script>
import { setComputed } from '@state/helpers'
import Layout from '@layouts/main'

import TeamCarousel from "@components/TeamCarousel";

import TheFooter from '../layouts/TheFooter'

export default {
  components: { Layout, TeamCarousel, TheFooter },
  data() {
    return {
      banner: {
        "zh-TW": {
          title: "teamBanner.vue",
          image: require('@assets/images/team/team_banner.jpg'),
          content: "你的未來不是夢",
          content2: "對於夥伴以循序漸進的訓練為主，<br class='d-block d-lg-none'>根據夥伴不同的專長給予不同的教育方式，<br class='d-block d-lg-none'>邁出追逐夢想的第一步，<br>橘色大家庭與你一起實現",
          class_name: "",
          hasMask: 0,
        },
        "en": {
          title: "teamBanner.vue",
          image: require('@assets/images/team/team_banner.jpg'),
          content: "Your future is not just a dream",
          content2: "By giving step-by-step training and personalized education, the Orange family helps each of our partners to take the first steps toward their dream and make their dreams come true",
          class_name: "",
          hasMask: 0,
        }
      },
      slogan: {
        "zh-TW": {
          title: "teamSlogan.vue",
          items: [
            {
              title: 'cultivate',
              sub_title: '悉心培育',
              title_image_big: require('@assets/images/team/team_sub_title_big_1.svg'),
              title_image: require('@assets/images/team/team_title_1.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_1.svg'),
              image: require('@assets/images/team/team_slogan_1x2.jpg'),
              content: "你可以身懷絕技<br>同時也可以擁有一顆<br>無比熱忱的心！",
              content2: "橘色集團，以良好的工作環境、優質的企業文化、完整的教育訓練，建立工作與生活品質兼顧的雙贏。橘色不只培養你的專業，更讓你擁有實現夢想的能力和實力。"
            },
            {
              title: 'family',
              sub_title: '家庭與夥伴',
              title_image_big: require('@assets/images/team/team_sub_title_big_2.svg'),
              title_image: require('@assets/images/team/team_title_2.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_2.svg'),
              image: require('@assets/images/team/team_slogan_2x2.jpg'),
              content: "家庭般的革命情誼<br>能將背後託付的<br>好夥伴。",
              content2: "橘色以在加法中的「零」為本位精神，讓每位夥伴樂於工作、保有初心；以同理心對待彼此，培養如家人般的情誼及默契，並且能相互扶持鼓勵、一同並肩作戰，讓每個人能無後顧之憂地展現最大潛能。"
            },
            {
              title: 'dream',
              sub_title: '前進夢想',
              title_image_big: require('@assets/images/team/team_sub_title_big_3.svg'),
              title_image: require('@assets/images/team/team_title_3.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_3.svg'),
              image: require('@assets/images/team/team_slogan_3x2.jpg'),
              content: "夢想不再只是夢想<br>你可以展翅高飛!",
              content2: "橘色結合了紅色的能量與黃色的快活， 橘色代表熱情、魅力、幸福、決心、成就、激勵、創造力及吸引力。因此我們以人為出發點，尊重每位夥伴，並能激發夥伴們的潛能，引領你們築夢踏實。成功不是完成式，而是進行式！"
            }
          ]
        },
        "en":  {
          title: "teamSlogan.vue",
          items: [
            {
              title: 'cultivate',
              sub_title: 'cultivate',
              title_image_big: require('@assets/images/team/team_sub_title_big_1.svg'),
              title_image: require('@assets/images/team/team_title_1.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_1.svg'),
              image: require('@assets/images/team/team_slogan_1x2.jpg'),
              content: "You can be well-equipped with talent and have a heart full of enthusiasm",
              content2: "With a great working environment, excellent company culture and complete education and training, Orange Corporation cares for the quality of work and life its staff enjoys. It cultivates each partner’s professional ability and helps them to realize their dreams."
            },
            {
              title: 'family',
              sub_title: 'family',
              title_image_big: require('@assets/images/team/team_sub_title_big_2.svg'),
              title_image: require('@assets/images/team/team_title_2.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_2.svg'),
              image: require('@assets/images/team/team_slogan_2x2.jpg'),
              content: "Family-like relationship good partners that you can trust",
              content2: "One of Orange Corporation’s basic principles is to bring everything back to its origins, allowing each partner to enjoy work while still keeping their initial intention in mind. Our partners treat each other with empathy and strive to build a family-like relationship. We support and encourage each other, take on challenges together, and allow each other to find fulfillment without worry."
            },
            {
              title: 'dream',
              sub_title: 'dream',
              title_image_big: require('@assets/images/team/team_sub_title_big_3.svg'),
              title_image: require('@assets/images/team/team_title_3.svg'),
              sub_title_image: require('@assets/images/team/team_sub_title_3.svg'),
              image: require('@assets/images/team/team_slogan_3x2.jpg'),
              content: "A dream is no longer just a dream you can spread your wings and fly high",
              content2: "Orange combines the energy of red with the cheerfulness of yellow. It represents passion, charm, happiness, determination, achievement, encouragement, creativity and attraction. We take people as the core of our business, respecting every partner. We inspire their potential and help them to realize their dreams. On the road to success, we keep on moving on."
            }
          ]
        },
      },
      member: {
        "zh-TW": [
          {
            title: "顧客關係主任",
            sub_title: "橘色涮涮屋",
            image: require('@assets/images/team/team_member_陳柏彥.jpg'),
            image_m: require('@assets/images/team/team_member_陳柏彥.jpg'),
            content: {
              subTitle: "聽聽我們的夥伴怎麼說",
              title: '人，是橘色最重要的核心',
              content:
                '任職這麼久以來，感受到橘色以人為本、以人起家的堅持。始終將客人的感受置於首位，卻又不失對夥伴之間的照顧與關懷。在食材的挑選、品質與味道不斷傳承與創新，讓顧客每次的回顧都會有新的感受，著實的把「人」「情」「味」三字發揮到極致。原來人家常說的幸福企業就在我身邊！',
              name: '陳柏彥',
              sign: require('@assets/images/team/team_member_sign_陳柏彥.png'),
            }
          },
          {
            title: "櫃檯副主任",
            sub_title: "橘色涮涮屋",
            image: require('@assets/images/team/team_member_Abby.jpg'),
            image_m: require('@assets/images/team/team_member_Abby.jpg'),
            content: {
              title: '傳遞溫暖的第一印象，是我創造的最大價值',
              content:
                '作為櫃檯夥伴，我們扮演著成功第一步的關鍵者，永遠是第一線接觸客人最重要的門面。我深信，溫暖是具有傳染力的，當我站在客人的角度為他們著想，透過貼心、耐心及暖心的互動，將這份溫暖傳遞下去並且創造無數個與客人間的感動連結與故事，是我最引以為傲的成就！',
              name: 'Abby',
              sign: require('@assets/images/team/team_member_sign_Abby.png'),
            }
          },
          {
            title: "店長",
            sub_title: "M One Café",
            image: require('@assets/images/team/team_member_Yvonne.jpg'),
            image_m: require('@assets/images/team/team_member_Yvonne.jpg'),
            content: {
              title: '只要把夥伴照顧好，自然而然客人也會被照顧好',
              content:
                '店長，是掌握店鋪營運的靈魂人物，負責維繫企業與顧客之間的關係。我堅信真心對待夥伴能建立團隊凝聚力，激勵他們發揮潛力持續發光發熱。而我也深信：只要把夥伴照顧好，自然而然客人也會被照顧好！我喜歡把客人當朋友般的招呼，當我致力於創造客人美好的用餐體驗時，那個瞬間我也感受到幸福與美好。',
              name: 'Yvonne',
              sign: require('@assets/images/team/team_member_sign_Yvonne.png'),
            }
          },
          {
            title: "資深主廚",
            sub_title: "橘色涮涮屋",
            image: require('@assets/images/team/team_member_蔡閔秋.jpg'),
            image_m: require('@assets/images/team/team_member_蔡閔秋.jpg'),
            content: {
              title: '為眾人創造美味料理，是我的使命',
              content:
                '在橘色，對美食不斷的追求是我的憧憬，並時時提醒自己身為廚師的初心。公司全然的信任以及與其他夥伴的默契和相互體諒，讓我對自己的工作充滿責任感。而公司安排的教育訓練課程，讓我能有機會可以挑戰自己、精進廚藝。我熱愛我的工作，為眾人創造美味料理是我的使命。',
              name: '蔡閔秋',
              sign: require('@assets/images/team/team_member_sign_2.png'),
            }
          },
        ],
        "en": [
          {
            title: "Customer Relations Officer",
            sub_title: "Orange Shabu",
            image: require('@assets/images/team/team_member_陳柏彥.jpg'),
            image_m: require('@assets/images/team/team_member_陳柏彥.jpg'),
            content: {
              subTitle: "Listen to what our partners say",
              title: '"People" are the core of Orange',
              content:
                "Throughout my tenure here at Orange, I've truly experienced the unwavering dedication to a people-first ethos and the founding principle centered around individuals. Consistently placing customer satisfaction above all else, while also ensuring a nurturing and supportive environment among colleagues. Through a relentless commitment to innovation in ingredient selection, quality, and flavor, we've managed to provide customers with fresh experiences every time they return. It's remarkable how this company embodies the essence of “people,” “empathy,” and “flavor.” Turns out, the concept of a happy workplace isn't just a saying – it's right here beside me!",
              name: 'Bo-yan Chen',
              sign: require('@assets/images/team/team_member_sign_陳柏彥.png'),
            }
          },
          {
            title: "Assistant Front Desk Manager",
            sub_title: "Orange Shabu",
            image: require('@assets/images/team/team_member_Abby.jpg'),
            image_m: require('@assets/images/team/team_member_Abby.jpg'),
            content: {
              title: 'Creating a warm first impression is my number one priority',
              content:
                "As front desk partners, we play a pivotal role as the first step towards success, always serving as the crucial initial point of contact with our guests. I firmly believe that warmth is contagious; when I empathize with our guests and prioritize their needs from their perspective, and through thoughtful, patient, and heartfelt interactions, passing on this warmth creates countless moments of connection and touching stories with our guests. It's my proudest achievement!",
              name: 'Abby',
              sign: require('@assets/images/team/team_member_sign_Abby.png'),
            }
          },
          {
            title: "Manager",
            sub_title: "M One Café",
            image: require('@assets/images/team/team_member_Yvonne.jpg'),
            image_m: require('@assets/images/team/team_member_Yvonne.jpg'),
            content: {
              title: 'Happy colleagues, happy customers!',
              content:
                "The store manager is the heart and soul of daily operations, tasked with nurturing the relationship between the business and its customers. I'm a firm believer that genuine treatment of colleagues cultivates team unity, motivating them to continually excel and shine. I also believe that when we take care of our colleagues, it naturally extends to taking care of our customers too! I enjoy welcoming customers like my own friends. When I'm focused on crafting a delightful dining experience for them, I feel a sense of happiness and fulfillment in that moment.",
              name: 'Yvonne',
              sign: require('@assets/images/team/team_member_sign_Yvonne.png'),
            }
          },
          {
            title: "Senior Chef",
            sub_title: "Orange Shabu",
            image: require('@assets/images/team/team_member_蔡閔秋.jpg'),
            image_m: require('@assets/images/team/team_member_蔡閔秋.jpg'),
            content: {
              title: 'Creating delicious dishes for others is my mission',
              content:
                'At Orange, my aspiration is the continual pursuit of culinary excellence, a reminder of my original intent as a chef. The unwavering trust from the company and the mutual understanding and support among colleagues instill a strong sense of responsibility in me towards my work. Thanks to the educational training programs provided by the company, I have the chance to push my limits and enhance my culinary skills. I love what I do; creating delicious dishes for others is my mission.',
              name: 'Min-Chiu Tsai',
              sign: require('@assets/images/team/team_member_sign_2.png'),
            }
          },
        ],
      },
      join: {
        'zh-TW': {
          title: "現在就邁出夢想的第一步，<br>橘色大家庭一起與你一同實現。"
        },
        en: {
          title: "Take the first step toward your dream now,<br>The Orange family will help you realize it."
        }
      },
      window_w: 0,
      options: {
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        navigation: true,
      },
    }
  },
  computed: {
    ...setComputed,
    bannerModule() {
      return this.currentLanguage === 'zh-TW' ? this.banner['zh-TW'] : this.banner['en'];
    },
    sloganModule() {
      return this.currentLanguage === 'zh-TW' ? this.slogan['zh-TW'] : this.slogan['en'];
    },
    memberModule() {
      return this.currentLanguage === 'zh-TW' ? this.member['zh-TW'] : this.member['en'];
    },
    joinModule() {
      return this.currentLanguage === 'zh-TW' ? this.join['zh-TW'] : this.join['en'];
    },
    titleTranformStyle() {
      const originWidth = 1920;
      const windthWidth = this.window_w;

      if(this.window_w > 991) {
        let scale = this.window_w < originWidth ? 1 / (originWidth / windthWidth) : 1;
        if(scale < 0.7) {
          scale = 0.7
        }

        return {
          transform: `scale(${scale}) translateY(-${(1 - scale) * 50}%) translateX(-${(1 - scale) * 150}px)`,
          '-webkit-transform': `scale(${scale}) translateY(-${(1 - scale) * 50}%) translateX(-${(1 - scale) * 150}px)`,
          marginBottom: `-${(1 - scale) * 300}px`,
        }
      }else {
        return {}
      }

    },
    contentTranformStyle() {
      const originWidth = 1920;
      const windthWidth = this.window_w;
      if(this.window_w > 991) {
        let scale = this.window_w < originWidth ? 1 / (originWidth / windthWidth) : 1;
        if(scale < 0.7) {
          scale = 0.7
        }

        return {
          transform: `scale(${scale}) translateY(-${(1 - scale) * 90}%) translateX(-${(1 - scale) * 150}px)`,
          '-webkit-transform': `scale(${scale}) translateY(-${(1 - scale) * 90}%) translateX(-${(1 - scale) * 150}px`,
          marginBottom: `-${(1 - scale) * 300}px`,
        }
      }else {
        return  {}
      }

    }
  },
  mounted() {
    this.getWindowWidth();
    window.addEventListener('resize', this.getWindowWidth)
  },
  destroyed() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  methods: {
    getWindowWidth(){
      this.window_w = document.body.clientWidth
    }
  }
}

</script>

<template>
  <Layout>
    <full-page :options="options" ref="fullpage">
      <section class="section" style="background: #453830;">
        <div :class="$style.banner" class="row" :style="{ backgroundImage: `url(${ bannerModule.image})` }">
          <h1 v-fade-up :class="$style.title">{{ bannerModule.content }}</h1>
        </div>
      </section>
      <section :class="$style.sectionBannerA" class="section">
        <h2 v-fade-up :class="$style.title" v-html="bannerModule.content2"></h2>
      </section>
      <section :class="$style.sectionSloganA" class="section">
        <div class="row">
          <div :class="$style.textBox">
            <div :class="[$style.content, $style.isLeft]">
              <div v-fade-up :class="$style.titleBox" :style="titleTranformStyle">
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[0].title"
                  :class="$style.titleBigImage"
                  :src="sloganModule.items[0].title_image_big" />
                <img
                  v-else
                  v-fade-up
                  :alt="sloganModule.items[0].title"
                  :class="$style.titleBigImage"
                  :src="sloganModule.items[0].title_image" />
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[0].sub_title"
                  :class="$style.subTitleImage"
                  :src="sloganModule.items[0].sub_title_image" />
                <img
                  v-fade-up
                  :alt="sloganModule.items[0].title"
                  :class="$style.titleImage"
                  :src="sloganModule.items[0].title_image" />
              </div>
              <div :class="$style.contentBox" :style="contentTranformStyle">
                <h4 v-fade-up :class="$style.contentA" v-html="sloganModule.items[0].content"></h4>
                <div :class="$style.imgBox" class="d-lg-none d-block">
                  <img :alt="sloganModule.items[0].title" v-fade-up :src="sloganModule.items[0].image">
                </div>
                <p v-fade-up :class="$style.contentB">{{ sloganModule.items[0].content2 }}</p>
              </div>
            </div>
          </div>
          <div v-fade-up :class="$style.imgBox" class="d-none d-lg-block text-right">
            <img :alt="sloganModule.items[0].title" :src="sloganModule.items[0].image">
          </div>
        </div>
      </section>
      <section :class="$style.sectionSloganB" class="section">
        <div class="row">
          <div v-fade-up :class="$style.imgBox" class="d-none d-lg-block text-left">
            <img :alt="sloganModule.items[1].title" :src="sloganModule.items[1].image">
          </div>
          <div :class="$style.textBox">
            <div :class="[$style.content, $style.isRight]">
              <div :class="$style.titleBox" :style="titleTranformStyle">
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[1].title"
                  :class="$style.titleBigImage"
                  :src="sloganModule.items[1].title_image_big" />
                <img
                  v-else
                  v-fade-up
                  :alt="sloganModule.items[1].title"
                  :class="$style.titleBigImage"
                  :src="sloganModule.items[1].title_image" />
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[1].sub_title"
                  :class="$style.subTitleImage"
                  :src="sloganModule.items[1].sub_title_image" />
                <img
                  v-fade-up
                  :alt="sloganModule.items[1].title"
                  :class="$style.titleImage"
                  :src="sloganModule.items[1].title_image" />
              </div>
              <div :class="$style.contentBox" :style="contentTranformStyle">
                <h4 v-fade-up :class="$style.contentA" v-html="sloganModule.items[1].content"></h4>
                <div v-fade-up :class="$style.imgBox" class="d-lg-none d-block text-right">
                  <img :alt="sloganModule.items[1].title" :src="sloganModule.items[1].image">
                </div>
                <p v-fade-up :class="$style.contentB">{{ sloganModule.items[1].content2 }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section :class="$style.sectionSloganC" class="section">
        <div class="row">
          <div :class="$style.textBox">
            <div :class="[$style.content, $style.isLeft]">
              <div :class="$style.titleBox" :style="titleTranformStyle">
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[2].title"
                  :class="$style.titleBigImage"
                  :src="sloganModule.items[2].title_image_big" />
                <img
                  v-else
                  v-fade-up
                  :alt="sloganModule.items[2].title"
                  :class="$style.titleBigImageEn"
                  :src="sloganModule.items[2].title_image" />
                <img
                  v-if="currentLanguage === 'zh-TW'"
                  v-fade-up
                  :alt="sloganModule.items[2].sub_title"
                  :class="$style.subTitleImage"
                  :src="sloganModule.items[2].sub_title_image" />
                <img
                  v-fade-up
                  :alt="sloganModule.items[2].title"
                  :class="$style.titleImage"
                  :src="sloganModule.items[2].title_image" />
              </div>
              <div :class="$style.contentBox" :style="contentTranformStyle">
                <h4 v-fade-up :class="$style.contentA" v-html="sloganModule.items[2].content" style="margin-top: 20px;"></h4>
                <div v-fade-up :class="$style.imgBox" class="d-lg-none d-block">
                  <img :alt="sloganModule.items[2].title" :src="sloganModule.items[2].image">
                </div>
                <p v-fade-up :class="$style.contentB">{{ sloganModule.items[2].content2 }}</p>
              </div>
            </div>
          </div>
          <div v-fade-up :class="$style.imgBox" class="d-none d-lg-block">
            <img :alt="sloganModule.items[2].title" :src="sloganModule.items[2].image">
          </div>
        </div>
      </section>
      <section v-fade-up :class="$style.sectionTeamCarousel" class="section">
        <TeamCarousel :list="memberModule" :current-language="currentLanguage"></TeamCarousel>
      </section>
      <section :class="$style.sectionJoin" class="section">
        <h3 v-fade-up :class="$style.subTitle" v-html="joinModule.title"></h3>
        <div :class="$style.linkBox">
          <h2 v-fade-up :class="$style.title">{{$t('global.JOIN_SLOGAN')}}</h2>
          <a target="_blank" href="https://www.104.com.tw/company/6cwvhm0?page=1&pageSize=20&order=undefined&asc=undefined&jobsource=joblist_b_relevance&sel_main_area=0" v-fade-up="{delay: 3}" :class="$style.btnGo">
            {{$t('global.GOTO')}}<span :class="$style.num"> 104 </span>{{$t('global.JOB_BANK')}}
          </a>
        </div>
      </section>
      <TheFooter
        class="section fp-auto-height"
        :class="$style['about_footer']"
      />
    </full-page>
    
  </Layout>
</template>
<style lang="scss" module>
  .banner {
    height: calc(100vh - 130px);
    background: #7e6441 center;
    background-size: cover;
    margin-top: -1px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Noto Serif TC', serif;
    color: #fff;
    z-index: 0;
    @include touch {
      height: calc(100vh - 70px);
    }
    .title {
      @include font(3rem, 56px, 22px, 500);
      position: relative;
      z-index: 1;
      text-indent: 22px;
      text-align: center;
      margin-left: 15px;
      margin-right: 15px;
      // white-space: nowrap;
      @include touch {
        @include font(2rem, null, 8px, null);
        position: relative;
        z-index: 1;
        text-indent: 10px;
      }
      &:before {
        content: '';
        background: #ffffff;
        position: absolute;
        bottom: -5rem;
        height: 40px;
        width: 1px;
        left: 50%;
      }
    }
    &:before {
      @include bg-mask(rgba(#453830, 0.3));
    }
  }
  // sectionBoss
  // sectionBannerA
  // sectionBannerB
  .sectionBannerA {
    background: #453830;
    // padding: 129.5px 0;
    text-align: center;
    font-family: 'Noto Serif TC', serif;
    @include touch {
      // padding: 21px 0;
    }
    .title {
      @include font(22px, 1.95, 6.6px, 600);
      color: #fff;
      margin-bottom: 0;
      @include touch {
        @include font(14px, 26px, 1px, null);
        padding: 0 15px;
      }
    }
    :global {
      .fp-tableCell {
        display: flex;
        align-items: center;
        justify-content: center;
        
      }
    }
  }

  .sectionSloganA, .sectionSloganC {
    .imgBox {
      position: relative;
    }
  }



  .sectionSloganA, .sectionSloganB, .sectionSloganC {
    // padding: 15rem 0 10rem;
    @include touch {
      // padding: 40px 0 60px;
    }
    .textBox {
      position: relative;
      width: 47vw;
      padding-right: 15px;
      padding-left: 15px;
      @media screen and (max-width: 1400px) {
        max-width: 40vw;
      }
      @include touch {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .content {
        width: 430px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        @include touch {
          width: 100%;
          text-align: center;
        }
        &.isLeft {
          transform-origin: bottom right;
          margin-left: auto;
          .contentBox {
            position: relative;
            top: 2rem;
            transform-origin: bottom right;
          }
          .titleBox {
            transform-origin: bottom right;
            top: -5rem;
            @include touch {
              top: 0;
            }
          }
        }
        &.isRight {
          transform-origin: bottom left;
          margin-right: auto;
          margin-left: 8rem;
          @include touch {
            margin-left: 0;
          }
          .contentBox {
            position: relative;
            top: 2rem;
            transform-origin: bottom left;
          }
          .titleBox {
            transform-origin: bottom left;
            top: -5rem;
            left: -17.5rem;
            @include touch {
              top: 0;
              left: 0;
            }
          }
        }
        .titleBox {
          z-index: 1;
          position: relative;
          @include touch {
            margin-bottom: 20px;
          }
          .titleBigImage {
            display: block;
            position: absolute;
            top: 10px;
            @include touch {
              display: none;
            }
          }
          .titleBigImageEn {
            display: block;
            position: absolute;
            top: 10px;
            @include touch {
              display: none;
            }
          }
          .subTitleImage {
            display: none;
            @include touch {
              max-width: 100%;
              height: 15px;
              margin: 13px auto 13px;
              display: block;
            }
          }
          .titleImage {
            display: none;
            @include touch {
              max-width: 100%;
              height: 24px;
              margin: 0 auto;
              display: block;
            }
          }
          .subtitle {
            @include font(28px, null, 5px, 200);
            font-family: 'Noto Serif TC', serif;
            margin-bottom: 1rem;
            @include touch {
              @include font(16px, null, null, null);
              margin-bottom: 0.5rem;
            }
          }
          .title {
            @include font(130px, 0.9em, 10px, 200);
            text-transform: uppercase;
            @include touch {
              @include font(48px, null, 8px, null);
            }
          }
        }
        .contentA {
          @include font(37px, 1.59, 5.85px, 500);
          margin-top: 24px;
          margin-bottom: 40px;
          font-family: "Noto Serif TC", serif;
          @include touch {
            @include font(18px !important, 1.33, 3.6px, 500);
            margin-top: 0;
            margin-bottom: 20px;
          }
        }
        .contentB {
          @include font(18px, 1.71, 2.04px, 300);
          margin-bottom: 3rem;
          width: 20.2em;
          @include touch {
            @include font(14px, null, 1.82px, null);
            padding: 0 1.5rem;
            text-align: left;
            margin-bottom: 0;
            width: 100%;
          }
        }
      }
    }
    .imgBox {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      @include touch {
        padding: 0 4.5rem;
        margin-bottom: 30px;
      }
      img {
        max-width: 100%;
      }
    }
    :global {
      .fp-tableCell {
        display: flex;
        align-items: center;
        justify-content: center;
        @include touch {
          display: inherit;
        }
      }
    }
  }

  .sectionSloganA {
    background: #80715c;
    color: #e6e0d8;
  }
  .sectionSloganB {
    background: #ad9d8b;
    color: #fff;
    .textBox {
      .content {
        .contentA {
          @include font(37px, null, null, null);
        }
        .contentB {
          width: 19.2em;
          @include touch {
            width: 100%;
            padding-right: 20px;
          }
        }
      }
    }
  }
  .sectionSloganC {
    background: #e6e6e6;
    color: #5e4f3a;
    .textBox {
      .content {
        .contentB {
          width: 20.6em;
          @include touch {
            width: 100%;
            padding-right: 20px;
          }
        }
      }
    }
  }

  .sectionTeamCarousel {
    padding: 0;
    position: relative;
    z-index: 0;
    background-color: #e6e6e6;
    @include touch {
      background-color: #f5b18c;
    }
  }

  .sectionJoin {
    font-family: 'Noto Serif TC', serif;
    // padding: 208px 0 230px;
    background: #e6e6e6;
    text-align: center;
    @include touch {
      // padding: 40px 0 70px;
    }
    .subTitle {
      @include font(36px, 56px, 7px, 500);
      color: #453830;
      @include touch {
        @include font(14px, 2, 2.8px, null);
      }
    }
    .linkBox {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 75px;
      @include touch {
        flex-direction: column;
        padding-top: 1rem;
      }
      .title {
        @include font(80px, 59px, 8px, 400);
        color: #e85400;
        padding: 0 1rem;
        @include touch {
          @include font(40px, null, null, null);
          margin-bottom: 2rem;
        }
      }
      .btnGo {
        @include font(24px, 46px, 6px, 500);
        background: #453830;
        border-radius: 5px;
        color: #fff;
        padding: 0.5rem 93px 0.5rem 51px;
        margin: 0 1rem 0 37px;
        position: relative;
        @include touch {
          @include font(22px, null, null, null);
          padding: 0.5rem 83px 0.5rem 49px;
          margin: 0 auto;
        }
        .num {
          font-family: Palatino, serif;
          letter-spacing: 2.88px;
          font-weight: 400;
        }
        &:hover {
          text-decoration: none;
          background: #ad9d8b;
        }
        &:before {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 11px 0 11px 20px;
          border-color: transparent transparent transparent #ffffff;
          content: "";
          position: absolute;
          top: 50%;
          right: 44px;
          margin-top: -11px;
          @include touch {
            right: 33px;
          }
        }
      }
    }
    :global {
      .fp-tableCell {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .about_footer {
    padding-top: 0;
    padding-bottom: 18px;
    @include touch {
      padding: 18px 44px;
    }
    :global {
      .d-flex {
        height: 300px;
        @include touch {
          height: auto;
        }
      }
    }
  }
</style>
